import React from 'react';
import { Pagination, PaginationItem, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const PaginationRounded = ({ count, page, onChange }) => {
  return (
    <Box 
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
    >
      <Pagination
        count={count}
        page={page}
        onChange={onChange}
        variant="outlined"
        shape="rounded"
        color="primary"
        renderItem={(item) => (
          <PaginationItem
            component={Link}
            to={`?page=${item.page}`}
            {...item}
            sx={{
              '&.Mui-selected': {
                backgroundColor: '#362a58ff',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#000000ff',
                },
              },
              '&:hover': {
                backgroundColor: 'rgba(127, 89, 235, 0.08)',
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default PaginationRounded;